var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('vue-recaptcha',{ref:"recaptcha",attrs:{"loadRecaptchaScript":"","language":_vm.language,"sitekey":_vm.sitekey},on:{"verify":_vm.handleVerify}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }